import { Close, DataObject, Replay } from "@mui/icons-material";
import { AppBar, Box, Card, Dialog, DialogContent, DialogTitle, IconButton, List, ListItem, ListItemText, Toolbar, Typography } from "@mui/material";
import React, { useContext } from "react";
import { BrandContext } from "../../../../contexts/BrandContext";
import { LoadingBox } from "../../UniversalComponents";
import { SchoolRulesContext } from "./SchoolRulesContext";
import EmailContent from "./EmailContent";



export default function TestRuleDialogue(){

const context = useContext(SchoolRulesContext);

const brandContext = useContext(BrandContext);

const {
    closeTestTemplateDialogue,
    showTestTemplateDialogue,
    testingRuleTemplateTitle,
    testTemplateLoading,
    testRuleTemplate,
    grabPlaceholders,
    testRuleName='',
    testRuleId,
    testEmailBody='',
    testEmailSubject='',
    testEmailErrors=[]
} = context;

const {
    textContent:{
        rulesWidget_testRule:testRuleText,
        rulesWidgetFormLabel_subject:subjectText,
        errorsFound
    }
} = brandContext;

return (
<Dialog
    fullScreen
    onClose={closeTestTemplateDialogue}
    open={showTestTemplateDialogue}
    >
    <AppBar sx={{ position: 'relative' }}>
        

        
        <Toolbar sx={{ justifyContent: 'space-between' }}>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                {testRuleText} - {testRuleName}
            </Typography>
            <IconButton
                edge="start"
                color="inherit"
                onClick={()=>{grabPlaceholders(testRuleId)}}
                aria-label="close"
                >
                <DataObject />
            </IconButton>
            <IconButton
                edge="start"
                color="inherit"
                onClick={()=>{testRuleTemplate(testRuleId)}}
                aria-label="close"
                >
                <Replay />
            </IconButton>
            <IconButton
                edge="start"
                color="inherit"
                onClick={closeTestTemplateDialogue}
                aria-label="close"
                >
                <Close />
            </IconButton>
        </Toolbar>
    </AppBar>
    <DialogContent>
        <DialogTitle>
            {testingRuleTemplateTitle}
        </DialogTitle>
        <DialogContent>
            
            {testTemplateLoading ? 
                    <LoadingBox/>
                    :
                    <>
                    <Typography variant="h6">{subjectText}: {testEmailSubject}</Typography>
                    {testEmailErrors.length > 0 ?  
                        <Box>
                            <Typography variant="h6">{errorsFound}</Typography>
                            <List>
                            {testEmailErrors.map((error,index)=>(
                                <ListItem key={index}>
                                    <ListItemText>{error}</ListItemText>
                                </ListItem>
                            ))}
                            </List>
                        </Box>
                        :
                        <Card sx={{marginTop:1}}>
                            <EmailContent htmlContent={testEmailBody}/>
                        </Card>
                    }
                    </>
                }
            
        </DialogContent>
    </DialogContent>
</Dialog>);
}